import React from 'react';
import './header-steps.scss';

enum StepType {
  current = 'current',
  passed = 'passed',
  upcoming = 'upcoming',
}

const getDisplayStyle = (type: StepType) => {
  if (type === StepType.current) {
    return {
      backgroundColor: '#000000',
      lableColor: '#000000',
      stepColor: '#FFFFFF',
      borderColor: '#BFBFBF',
    };
  }
  if (type === StepType.passed) {
    return {
      backgroundColor: '#2ABB7F',
      lableColor: '#2ABB7F',
      stepColor: '#FFFFFF',
      borderColor: '#2ABB7F',
    };
  }
  return {
    backgroundColor: '#FFFFFF',
    lableColor: '#8C8C8C',
    stepColor: '#000000',
    borderColor: '#BFBFBF',
  };
};

interface StepItem {
  id: number;
  label: string;
}

interface HeaderWithStepsProps {
  currentStep: number;
  steps: StepItem[];
}

export const HeaderWithSteps: React.FC<HeaderWithStepsProps> = ({
  currentStep = 0,
  steps,
}) => {
  return (
    <div className="header-steps-container">
      {steps.map((step, index) => {
        const stepType =
          step.id === currentStep
            ? StepType.current
            : step.id < currentStep
              ? StepType.passed
              : StepType.upcoming;

        const styles = getDisplayStyle(stepType);

        return (
          <div key={step?.id}>
            <div
              className="header-steps-container__step-circle"
              style={{
                backgroundColor: styles.backgroundColor,
                borderColor:
                  stepType === StepType.upcoming
                    ? styles.borderColor
                    : styles.backgroundColor,
              }}
            >
              <div
                className="header-steps-container__label font-semibold"
                style={{
                  color: styles.stepColor,
                }}
              >
                {index + 1}
              </div>
            </div>
            {step.id < steps.length && (
              <div
                className="header-steps--divider"
                style={{
                  backgroundColor: styles.borderColor,
                }}
              />
            )}
            <div
              className="header-steps-container__label step-label font-semibold"
              style={{
                color: styles.lableColor,
              }}
            >
              {step.label}
            </div>
          </div>
        );
      })}
    </div>
  );
};
